<template>

    <div class="topGather" ref="topGather" v-if="!$BRT.$active.shopPoint">

        <!--搜索模块-->
        <SearchMoudle v-show="!$mapStep.type && !$BRT.$urlParam.share.status ||($mapStep.type != 'poiDetail' && $mapStep.type !='planRoute' && $mapStep.type !='toPlanRoute' && $mapStep.type != 'toNAVING' && !$BRT.$urlParam.share.status && $BRT.$options.PoiListDrawer !=3)"></SearchMoudle>

        <!--设置起终点模块-->
        <StartAndEndMoudle v-show="$mapStep.type != 'toNAVING' && $mapStep.type !='toFilter' && ( $mapStep.type == 'planRoute' || $mapStep.type =='toPlanRoute')"></StartAndEndMoudle>

        <!--导航中提示模块-->
        <NavTipMoudle v-show="$mapStep.type == 'toNAVING' && $BRT.$NAVTO.NAVType != 'NAVINDICATE_END'"></NavTipMoudle>

        <!--区域触发$BRT.$NAVTO.NAVType == 'NAVINDICATE' -->
        <NavAreaPointMoudle v-show="$BRT.$NAVTO.NAVType == 'NAVINDICATE'"></NavAreaPointMoudle>
    </div>

</template>

<script>
    //引入相关模块
    import SearchMoudle from './modules/SearchModule'
    import StartAndEndMoudle from './modules/StartAndEndModule'
    import NavTipMoudle from './modules/NavTipModule'
    import NavAreaPointMoudle from './modules/NavAreaPointMoudle'
    export default {
            name: "TopGather",

            data(){
                return {}
            },

            methods:{},

            watch:{},

            computed:{},

            components:{

                SearchMoudle,

                StartAndEndMoudle,
                NavTipMoudle,
                NavAreaPointMoudle

            },

            mounted(){}


        }
</script>

<style lang="less">

</style>
